export class QrefPipdl4936Model {
  code: string;
  name: string;

  constructor() {
  }
}

